import { render, staticRenderFns } from "./border-color.vue?vue&type=template&id=622021fc&"
import script from "./border-color.vue?vue&type=script&lang=js&"
export * from "./border-color.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports